module.exports = __webpack_public_path__ + "static/media/double-master-closets.1b0762b3.svg";